import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/questionnaire.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/custom.scss";

import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/questionnairev2.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/customv2.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/accordian.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/anim.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/checklist.scss";
import "../../assets/FollowupOD/FollowupOD_V2/scss/modules/personaldetails.scss";


import { useContext, useEffect, useReducer, useState } from "react";
import { Api } from "../../api/Api";
import { getQueryString } from "../../Utility/QueryString";
import { useHistory } from "react-router-dom";
import { useFollowupLoad } from "../../Hooks/useFollowupLoad";
import { useFollowupUserQuestions } from "../../Hooks/useFollowupUserQuestions";
import { useSkippedLeads } from "../../Hooks/useSkippedLeads";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { useForm } from "react-hook-form";
import { useUserClickStore } from "../../Hooks/useClickDetailStore";
import { TrackUserActions } from "../../Utility/TrackUserActions";
import Signature from "../Includes/Layouts/FollowupOD/Signature";
import CreditCheckFlp from "../Includes/Layouts/FollowupOD/CreditCheckFlp";
import QuestionaireFlp from "../Includes/Layouts/FollowupOD/QuestionaireFlp";
import FlpODId from "../Includes/Layouts/FollowupOD/FlpODId";
import PreviewFlpOD from "../Includes/Layouts/FollowupOD/PreviewFlpOD";
import LoaderOD from "../Includes/Layouts/FollowupOD/LoaderOD";
import CreditCheckQuestions_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheckQuestions_FLP_OD";
import CreditCheck_FLP_OD_CONFIRM from "../Includes/Layouts/FollowupOD/CreditCheck_FLP_OD_CONFIRM";
import CreditCheck_Submit_Otp_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheck_Submit_Otp_FLP_OD";
import CreditCheck_Send_Otp_FLP_OD from "../Includes/Layouts/FollowupOD/CreditCheck_Send_Otp_FLP_OD";
import VerifyDataFlpOD from "../Includes/Layouts/FollowupOD/VerifyDataFlpOD";
import CreditCheckQuestions_FLP_OD_V2 from "../Includes/Layouts/FollowupOD/CreditCheckQuestions_FLP_OD_V2";
import QuestionaireFlpV2 from "../Includes/Layouts/FollowupOD/QuestionaireFlpV2";
import LoaderOD_V2 from "../Includes/Layouts/FollowupOD/LoaderOD_V2";
import Welcome_FLP from "../Includes/Layouts/FollowupOD/Welcome_FLP";
import Footer from "../Includes/Layouts/UFC_DC_V2/Footer";
import PreviewFlpOD_V2 from "../Includes/Layouts/FollowupOD/PreviewFlpOD_V2";
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import { getPageName } from "../../Constants/PageNames";
import { usePageLoad } from "../../Hooks/usePageLoad";
import EditDetails_FLP_OD from "../Includes/Layouts/FollowupOD/EditDetails_FLP_OD";
import T2aCheckFLPOD from "../Includes/Layouts/FollowupOD/T2aFlpOD";
import { MonthNumberArray } from "../../Constants/Constants";

import Signature_For_Prev from "../Includes/Layouts/FollowupOD/Signature_For_Prev";
import ChDocPreviewODV2 from "../Includes/Layouts/FollowupOD/ChDocPreviewODV2";


const Followup_OD_V2 = () => {
  const history = useHistory();
  const { loadFollowup } = useFollowupLoad();
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const { skippedLeads } = useSkippedLeads();
  // const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const { visitorParameters } = useContext(VisitorParamsContext);
  const [pendingQuestionnaire, setPendingQuestionnaire] = useState([]);
  const [showUserName, setUserName] = useState(null);
  const [uuid, setUuid] = useState(null);
  const [allFollowupData, setFollowupData] = useState(false);
  const [optionSelected] = useState([]);
  const [optionSelected76] = useState([]);
  const [t2aApiReqData, setT2aApiReqData] = useState({});
  const [stillAct, setStillAct] = useState("");
  const [cardOpenYr, setCardOpenYr] = useState([]);
  const [userEmail, setUserEmail] = useState();
  const [userSign, setUserSign] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const { userClickStore } = useUserClickStore();
  const { register, errors, trigger, setError, clearErrors, getValues } =
    useForm({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {},
      resolver: undefined,
      context: undefined,
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: true,
    });
  const [loader, setLoader] = useState(true);
  const [showSlides, setShowSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState("");
  const [userData, setUserData] = useState({});
  const [creditPendingSlides, setCreditPendingSlides] = useState([]);
  const queryString = getQueryString() ?? window.location.search.substring(1);
  const [showWelcome, setShowWelcome] = useState(true);
  const splitName = localStorage.getItem("split_name");
  const flp_source = allFollowupData.atp_sub6;
  const { savePageLoad, calledOnce } = usePageLoad();
  const [hasflgid, sethasflgid] = useState(null);
  const [chPosted, setChPosted] = useState(null);
  const [userLender, setUserLender] = useState("");
  const [iscakePosted, setIsCakePosted] = useState("");

  useEffect(() => {
    (async () => {
      const response = await Api.get(
        `/api/v1/followup/get-pending-details-od-v2?query_string=` + queryString,
        {}
      );
      console.log(response.data.status);

      if (response.data.status === "Success") {
        let questionPending = response.data.response.slides;
        let followup_data = response.data.response.followup_data;
        let uuid = response.data.response.uuid;
        let username = response.data.response.username;
        localStorage.setItem("uuid", uuid);
        let userId = response.data.response.user_id;
        let title = response.data.response.title;
        let fname = response.data.response.first_name;
        let lname = response.data.response.last_name;
        let tMName = response.data.response.middle_name;
        let email = response.data.response.email;
        let dob_day = response.data.response.dob_day;
        let edit_DOB = response.data.response.edit_DOB;
        let dob_yr = response.data.response.dob_yr;
        let dob_month = response.data.response.dob_month;
        let postcode = response.data.response.postcode;
        let address1 = response.data.response.address_id;
        let address_line1 = response.data.response.address_line1;
        let address_line2 = response.data.response.address_line2;
        let addressLine3 = response.data.response.address_line3;
        let addressLine4 = response.data.response.address_line4;
        let town = response.data.response.town;
        let district = response.data.response.district;
        let country = response.data.response.country;
        let county = response.data.response.county;
        let t2a_status = response.data.response.t2a_status;
        let split_name = response.data.response.split_name;
        let userSign = response.data.response.sign;
        let selectedBank = response.data.response.lender;
        let cc_pending_question = response.data.response.cc_pending_question;
        localStorage.setItem("flp_source", followup_data.atp_sub6);
        localStorage.setItem("allFollowupData", JSON.stringify(followup_data));
        localStorage.setItem("t2aValidation", t2a_status ? t2a_status : "0");
        localStorage.setItem("split_name", split_name);
        let Source = response.data.response.source;
        let txtEmail = response.data.response.email;
        let txtPhone = response.data.response.phone;
        let hasflgid = response.data.response.has_flg_id;
        let ch_posted = response.data.response.ch_posted;
        let signature_reconfirm = response.data.response.signature_reconfirm; 
        setUserLender(response.data.response.lender);
        setIsCakePosted(response.data.response.has_cake_posted);
        visitorParameters.email = email || false;
        visitorParameters.visitor_parameters.uuid = uuid || false;
        let dobMonthConv = response.data.response.dob_month ? MonthNumberArray[response.data.response.dob_month] : '';
        let slidesToShow = Object.entries(response.data.response)
          .filter(([key, value]) => value === "show")
          .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {});

        setT2aApiReqData({
          uuid: uuid,
          fName: fname,
          lName: lname,
          pCode: postcode,
          addressLine1: address_line1,
          day: dob_day,
          month: dobMonthConv,
          year: dob_yr,
          addressLine2: address_line2,
          postTown: town,
          country: country,
          title: title,
          addressLine3: addressLine3,
          addressLine4: addressLine4,
          county: county,
        });
        setUserData({
          userId: userId,
          uuid: uuid,
          title: title,
          txtFName: fname,
          txtLName: lname,
          txtMName: tMName,
          DobDay: dob_day,
          edit_DOB:edit_DOB,
          DobMonth: dob_month,
          DobYear: dob_yr,
          address1: address1,
          txtPostCode: postcode,
          txtHouseNumber: address_line1,
          txtAddress2: address_line2,
          txtAddress3: addressLine3,
          addressLine4: addressLine4,
          txtCounty: county,
          district:district,
          country: country,
          txtTown: town,
          source: Source,
          txtEmail: txtEmail,
          txtPhone: txtPhone,
          split_name: split_name,
        });
        setUserSign(userSign);
        setUserName(username);
        setUuid(uuid);
        setFollowupData(followup_data);
        setUserEmail(email);
        setSelectedBank(selectedBank);
        console.log("selectedBank", selectedBank);
        setCreditPendingSlides(cc_pending_question);
        sethasflgid(hasflgid);
        setChPosted(ch_posted);
        const flpResponse = await loadFollowup(
          "followup_load",
          followup_data,
          "followup-od",
          queryString,
          "od"
        );

        let slides = Object.keys(slidesToShow);
        console.log("slides", slidesToShow);
        if (slides.length === 0) {
          history.push(`/ThankyouFLP_OD?uuid=${uuid}`);
        }
        setShowSlides(slides);
        setTimeout(() => {
          setPendingQuestionnaire(questionPending);
          setLoader(false);
        }, 3000);
      } else {
        console.log("error");

        history.push(`/ThankyouFLP_OD`);
        return false;
      }
    })();
  }, []);

  // const saveUserAction = (e) => {
  //   try {
  //     const userDetails = TrackUserActions(e);
  //     if (userDetails) {
  //       const { page, action, click_type, source, user_uuid } = userDetails;

  //       userClickStore(user_uuid, page, action, click_type, source);
  //     }
  //   } catch (error) {
  //     console.error("Error saving user action:", error);
  //   }
  // };

  // useEffect(() => {
  //   const handleClick = (e) => {
  //     if (e.target.getAttribute("data-click-id")) {
  //       saveUserAction(e);
  //     }
  //   };

  //   window.addEventListener("click", handleClick);
  //   return () => {
  //     window.removeEventListener("click", handleClick);
  //   };
  // }, []);

  useEffect(() => {
    if (showSlides.length > 0) {
      slideChange(showSlides);
    }
  }, [showSlides]);

  const slideChange = (pendingArr) => {
    window.scrollTo(0, 0);
    let pendingCount = pendingArr.length;

    if (hasflgid == 1 && chPosted == 1) {
      history.push(`/ThankyouFLP_OD?uuid=${uuid}`);
      return false;
    } else if (pendingCount === 0) {
      history.push(`/ThankyouFLP_OD?uuid=${uuid}`);
      return false;
    }
    console.log("pendingArr", pendingArr, pendingArr[0], uuid);

    setCurrentSlide(pendingArr[0]);
  };

  const removeFromPending = (slidename) => {
    const index = showSlides.indexOf(slidename);
    if (index > -1) {
      showSlides.splice(index, 1);
    }
    console.log("showSlides", showSlides);
    slideChange(showSlides);
  };

  const handleWelcomeContinue = () => {

    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("flp_OD_proceed_btn_click"),
        status: "visited",
        source: flp_source,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          splitName,
          queryString,
          visitorParameters.data
        );
      })();
    }

    setShowWelcome(false);
    setLoader(true);

    // Simulate data load or navigation
    setTimeout(() => {
      setLoader(false);
      // Navigate or show next component
    }, 2000);
  };

  const addPending = (slidename) => {
    setShowSlides((prevSlides) => [slidename, ...prevSlides]);
    slideChange([slidename, ...showSlides]);
  };


  return (
    <>
      <GetVisitorsParams />
      {showWelcome && !loader && (
        <Welcome_FLP
          onContinue={handleWelcomeContinue}
          uuid={uuid}
          allFollowupData={allFollowupData}
        />
      )}
      <div className={`Followup_OD_V2`}>

        {loader && !showWelcome && <LoaderOD_V2 showLoader={true} />}
        {!showWelcome && !loader && currentSlide == "signature_reconfirm" && (
          <Signature_For_Prev
            allFollowupData={allFollowupData}
            uuid={uuid}
            cfirstName={showUserName}
            removeFromPending={removeFromPending}
            setUserSign={setUserSign}
            userSign={userSign}
            flp_source={flp_source}
            userLender={userLender}
            iscakePosted={iscakePosted}
          />
        )}
        {!showWelcome && !loader && currentSlide == "signature" && (
          <Signature
            allFollowupData={allFollowupData}
            uuid={uuid}
            cfirstName={showUserName}
            removeFromPending={removeFromPending}
            setUserSign={setUserSign}
          />
        )}

        {/* {!showWelcome && !loader && currentSlide == "signature" && (
          <Signature
            allFollowupData={allFollowupData}
            uuid={uuid}
            cfirstName={showUserName}
            removeFromPending={removeFromPending}
            setUserSign={setUserSign}
          />
        )} */}
        {!showWelcome && !loader && currentSlide == "editdetails_flp" && (
          <EditDetails_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!showWelcome && !loader && currentSlide == "send_otp_flp" && (
          <CreditCheck_Send_Otp_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
            addPending={addPending}
          />
        )}
        {!showWelcome && !loader && currentSlide == "submit_otp_flp" && (
          <CreditCheck_Submit_Otp_FLP_OD
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!showWelcome && !loader && currentSlide == "otp_confirmation_page" && (
          <CreditCheck_FLP_OD_CONFIRM
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}
        {!showWelcome && !loader && currentSlide == "creditCheck_Questions" && (
          <CreditCheckQuestions_FLP_OD_V2
            userData={userData}
            uuid={uuid}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
            selectedBank={selectedBank}
            creditPendingSlides={creditPendingSlides}
          />
        )}

        {!showWelcome && !loader && currentSlide == "questionnaire" && (
          <QuestionaireFlpV2
            questionSlides={pendingQuestionnaire}
            allFollowupData={allFollowupData}
            updatePending={setPendingQuestionnaire}
            removeFromPendingFollowup={removeFromPending}
            uuid={uuid}
          />
        )}
        {!showWelcome && !loader && currentSlide == "verify" && (
          <T2aCheckFLPOD
            uuid={uuid}
            t2aApiReqData={t2aApiReqData}
            allFollowupData={allFollowupData}
            removeFromPending={removeFromPending}
          />
        )}

        {!showWelcome && !loader &&
          (currentSlide == "preview" || currentSlide == "meritPage") && (
            <PreviewFlpOD_V2
              uuid={uuid}
              removeFromPending={removeFromPending}
              meritPage={showSlides.includes("meritPage")}
              queryString={queryString}
              allFollowupData={allFollowupData}
              userSign={userSign}
              selectedBank={selectedBank}
            />
          )}

        {!showWelcome && !loader && currentSlide == "chDocPreview" && (
            <ChDocPreviewODV2
              uuid={uuid}
              removeFromPending={removeFromPending}
              queryString={queryString}
              allFollowupData={allFollowupData}
              userSign={userSign}
            />
         )} 

        {!showWelcome && !loader && currentSlide == "idUpload" && (
          <FlpODId
            uuid={uuid}
            removeFromPending={removeFromPending}
            allFollowupData={allFollowupData}
          />
        )}
      </div>
    </>
  );
};

export default Followup_OD_V2;
